import './../../../node_modules/react-grid-layout/css/styles.css';
import './../../../node_modules/react-resizable/css/styles.css';
import './custom.css';

import React, {Component} from 'react';
import {getPopularStoresList, updatePopularStoreItem, removePopularStoreItem} from '../../modules/Api';
import {Col, Card, Button, notification} from 'antd';
import {END_POINT} from '../../constants/config';
import history from '../../modules/History';

import { Responsive as ResponsiveGridLayout } from 'react-grid-layout';
import ACL from '../../components/ACL';

class PopularStores extends Component {
    constructor() {
        super();
        this.state = {
            items: []
        }
    }
    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getPopularStoresList(query, (items) => {
            this.setState({items});
        });
    }
    onDragStop = (layout, oldItem, newItem, placeholder, e, element) => {
        updatePopularStoreItem(layout.sort((a, b) => b.y + a.y));
    }

    remove = (e,id) => {
        notification.open({
            message: `صبر کنید`,
        });
        removePopularStoreItem(id, (data) => {
            getPopularStoresList('', (items) => {
                this.setState({items});
            });
        })

    }
    render() {
        const items = this.state.items;

        return (
            <div style={{direction: 'ltr'}}>
                <ACL component="div" has_permission="popularstores_management|popularstores_add">
                    <Col span={20} offset={2}>
                        <Button type="primary" style={{marginBottom:'10px'}} onClick={() => history.item.push(`/popular-stores/add`)}>افزودن</Button>
                    </Col>
                </ACL>
                <Col span={20} offset={2}>
                    {Object.keys(items).map((popular, i) => {
                        return (
                            <Card  key={i} bodyStyle={{overflowX:'auto'}}
                            title={popular}
                            >
                            <ResponsiveGridLayout className="layout"
                            //compactType='horizontal'
                            onDragStop={this.onDragStop}
                            isResizable={false}
                            breakpoints={{lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0}}
                            cols={{lg: 12, md: 10, sm: 6, xs: 4, xxs: 2}}
                            rowHeight={50} width={600}>
                                {this.state.items[popular].sort((a, b) => a.order - b.order).map((pop, c) => {
                                    const gridStyle = {
                                        width: '100%',
                                        textAlign: 'center',
                                        cursor: 'move',
                                        float: 'right',
                                    };
                                    const removeStyle = {
                                        position: 'absolute',
                                        right: '10px',
                                        top: '10px',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        padding:'0 7px',
                                        background: '#ddd'
                                    };
                                    return (
                                        <div key={pop.id} data-key={pop.id} data-grid={{x: 1, y: 0, w: 3, h: 2}}>
                                            <Card.Grid style={gridStyle} title={pop.name} type="inner">
                                                <ACL component="div" has_permission="popularstores_management|popularstores_delete"><span style={removeStyle} onClick={(e) => this.remove(e, pop.id)}>&times;</span></ACL>
                                                {
                                                    pop.logo
                                                    &&
                                                    <img
                                                        style={{width:'50px'}}
                                                        src={`${pop.logo.includes('http') ? pop.logo : END_POINT + pop.logo}`}
                                                        alt={pop.name}
                                                    />
                                                }
                                            </Card.Grid>
                                        </div>
                                    );
                                })}
                            </ResponsiveGridLayout>
                            </Card>
                        );
                    })}
                </Col>
            </div>
        );
    }
}

export default PopularStores;


// WEBPACK FOOTER //
// ./src/containers/PopularStores/index.js